import $ from 'jquery'
import postContentSize from './content_size'

const update_step_3b = function(){
  const value = $('input[type=radio][name="decision_helper[frame_step_3_used]"]:checked').val()
  if(value == "3B"){
    $('.decision_helper_frame_step_3b').show()
  }else{
    $('.decision_helper_frame_step_3b').hide()
  }
}

$('input[type=radio][name="decision_helper[frame_step_3_used]"]').change(function() {
  update_step_3b()
});


const update_step_7a = function(){
  const value = $('#decision_helper_frame_step_6a').prop("checked")
  if(value){
    $('.decision_helper_frame_step_7a_moderate').show()
  }else{
    $('.decision_helper_frame_step_7a_moderate').hide()
  }

}
$('#decision_helper_frame_step_6a').change(function() {
  update_step_7a()
});


const update_step_10 = function(){
  const value = $('#decision_helper_frame_step_10_last_question_is_other').prop("checked")
  if(value){
    $('.decision_helper_frame_step_10_question_3').hide()
  }else{
    $('.decision_helper_frame_step_10_question_3').show()
  }

}

$('#decision_helper_frame_step_10_last_question_is_other').change(function() {
  update_step_10()
});

update_step_10()
update_step_7a()
update_step_3b()

$("select.logos").imagepicker()

$("#decision_helper_frame_step_2, #decision_helper_frame_step_2_decision, #decision_helper_frame_step_2a").on("change keyup paste", function(){
  var decision_helper_id = $('#decision_helper_id').val()
  var frame_step_2 = $('#decision_helper_frame_step_2').val()
  var frame_step_2_decision = $('#decision_helper_frame_step_2_decision').val()
  var frame_step_2a = $('#decision_helper_frame_step_2a').val()
  var fields = {frame_step_2: frame_step_2, frame_step_2_decision: frame_step_2_decision, frame_step_2a: frame_step_2a}
  postContentSize("frame_step_2", "/content_size/frame", { decision_helper_id: decision_helper_id, field_name: "frame_step_2", fields: fields })
  .done(function( data ) {
    if(data["valid"]) {
      $("#frame_step_2_error").hide()
    } else {
      $("#frame_step_2_error").show()
    }
  });
});

$("#decision_helper_frame_step_9, #decision_helper_preparation_enable").on("change keyup paste", function(){
  var decision_helper_id = $('#decision_helper_id').val()
  var frame_step_9 = $('#decision_helper_frame_step_9').val()
  var frame_step_9_preparation = document.getElementById('decision_helper_preparation_enable').checked
  var fields = {frame_step_9: frame_step_9, frame_step_9_preparation: frame_step_9_preparation}
  postContentSize("frame_step_9", "/content_size/frame", { decision_helper_id: decision_helper_id, field_name: "frame_step_9", fields: fields })
  .done(function( data ) {
    if(data["valid"]) {
      $("#frame_step_9_error").hide()
    } else {
      $("#frame_step_9_error").show()
    }
  });
});

$("#decision_helper_frame_step_3b").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_3b");
});

$("#decision_helper_frame_step_4").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_4");
});

$("#decision_helper_frame_step_5").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_5");
});

$("#decision_helper_frame_step_6").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_6");
});

$("#decision_helper_frame_step_7a_least").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_7a_least");
});

$("#decision_helper_frame_step_7a_moderate").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_7a_moderate");
});

$("#decision_helper_frame_step_7a_most").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_7a_most");
});

$("#decision_helper_frame_step_7b").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_7b");
});

$("#decision_helper_frame_step_10").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_10");
});

$("#decision_helper_frame_step_10_question_1").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_10_question_1");
});

$("#decision_helper_frame_step_10_question_2").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_10_question_2");
});

$("#decision_helper_frame_step_10_question_3").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_10_question_3");
});

$("#decision_helper_frame_step_21_question_1").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_21_question_1");
});

$("#decision_helper_frame_step_21_question_2").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_21_question_2");
});

$("#decision_helper_frame_step_21_question_3").on("change keyup paste", function(){
  defaultFrameHandler("frame_step_21_question_3");
});

function defaultFrameHandler(field_name){
  var decision_helper_id = $('#decision_helper_id').val()
  var field_value = $('#decision_helper_'+field_name).val()
  var fields = {}
  fields[field_name] = field_value
  postContentSize(field_name, "/content_size/frame", { decision_helper_id: decision_helper_id, field_name: field_name, fields: fields })
  .done(function( data ) {
    if(data["valid"]) {
     $("#"+field_name+"_error").hide()
    } else {
      $("#"+field_name+"_error").show()
    }
  });
}